import { render } from "./Ars.vue?vue&type=template&id=0ecd0c34&scoped=true"
import script from "./Ars.vue?vue&type=script&lang=js"
export * from "./Ars.vue?vue&type=script&lang=js"

import "./Ars.vue?vue&type=style&index=0&id=0ecd0c34&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ecd0c34"]])

export default __exports__